// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Drawer, Button, Panel, Checkbox, DatePicker, Input, useToaster, Message } from 'rsuite';
import { FaCalendar } from 'react-icons/fa';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import GenerateAccessUpdate from './GenerateAccessUpdate';
import GenerateMobileAccessUpdate from './GenerateMobileAccessUpdate';
import '../catalogue/styles.css';
import { useFormik } from 'formik';
import globalIP from '../../GlobelIP';
import axios from 'axios';

export default function GenerateAuthSlider({ open, close, editData }) {
  console.log(editData);

  const [activeButton, setActiveButton] = useState(1);
  const [editRestic, setEditRestic] = useState(false);
  const [editRestic2, setEditRestic2] = useState(false);
  const [editId, setEditId] = useState();
  const [emailList, setEmailList] = useState([]);
  const [typeCode, setTypeCode] = useState();
  const [linkCheckBox, setLinkCheckBox] = useState(false);
  const [mobileList, setMobileList] = useState([]);
  const [emailRestricCheckbox, setEmailRestricCheckbox] = useState(false);
  const [mobileRestricCheckbox, setMobileRestricCheckbox] = useState(false);
  const toaster = useToaster();
  const fetchData = async () => {
    const {
      data: { data }
    } = await axios.get(
      `${globalIP}/api/client-logins?populate=*&filters[typecode][$eq]=${editData.attributes.CatalogueCode}`
    );
    if (data && data.length > 0) {
      // const { Timeto, ...otherAttributes } = data[0].attributes;
      const { Timeto, ...otherAttributes } = data[data.length-1].attributes;
      formik.setValues({
        ...otherAttributes,
        Timeto: new Date(Timeto)
      });
      setEditId(data[0].id);
      setTypeCode(data[0].attributes.typecode);
      setEmailList(data[0].attributes.loginemailid);
      setMobileList(data[0].attributes.loginmobile);
      setLinkCheckBox(data[0].attributes.Timeto ? true : false);
      setEmailRestricCheckbox(data[0].attributes.loginemailid.length ? true : false);
      setMobileRestricCheckbox(data[0].attributes.loginmobile.length ? true : false);
    }
  };
  useEffect(() => {
    open && fetchData();
  }, [open]);
  const notify = (message, placement?, type?) => {
    toaster.push(
      <Message showIcon type={type || 'error'}>
        {message}
      </Message>,
      { placement: placement || 'topEnd' }
    );
  };
  const Submit = async (value, action) => {
    try {
      const data = await axios.put(`${globalIP}/api/client-logins/${editId}`, {
        data: {
          ...value,
          loginemailid: emailList.length ? emailList : [],
          loginmobile: mobileList.length ? mobileList : []
        }
      });
      if (data.statusText == 'OK') {
        action.resetForm();
        notify('Updated Successfully', '', 'success');
        close();
      } else {
        console.error('Something is wrong');
      }
    } catch (e) {
      console.error(e, 'GenerateAuthSliderUpdate');
    }
  };

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      bypassword: false,
      byemail: false,
      emailotp: false,
      bymobile: false,
      mobileotp: false,
      downloadppt: false,
      showfilter: false,
      setasdefault: false,
      SlideShow: false,
      SmartSearch:false,
      visualProduct:false,
    },
    onSubmit: async (value, action) => {
      const submitForm = async () => {
        await Submit(value, action);
      };
      if (value.byemail && value.bymobile && value.bypassword) {
        if (emailRestricCheckbox) {
          if (emailList.length) {
            if (mobileRestricCheckbox) {
              if (mobileList.length) {
                if (value.username && value.password) {
                  if (linkCheckBox && value.Timeto) {
                    await submitForm();
                  } else {
                    notify('Link Expiry date is required!');
                  }
                } else {
                  notify('Fill username and password');
                }
              } else {
                notify('Add at least one mobile number!');
              }
            } else {
              notify('Mobile Restrict is required');
            }
          } else {
            notify('Add at least one email!');
          }
        } else {
          notify('Email Restrict is required');
        }
      } else if (value.byemail && value.bymobile) {
        if (emailRestricCheckbox) {
          if (emailList.length) {
            if (mobileRestricCheckbox) {
              if (mobileList.length) {
                if (linkCheckBox && value.Timeto) {
                  await submitForm();
                } else {
                  notify('Link Expiry date is required!');
                }
              } else {
                notify('Add at least one mobile number!');
              }
            } else {
              notify('Mobile Restrict is required');
            }
          } else {
            notify('Add at least one email!');
          }
        } else {
          notify('Email Restrict is required');
        }
      } else if (value.byemail && value.bypassword) {
        if (emailRestricCheckbox) {
          if (emailList.length) {
            if (value.username && value.password) {
              if (linkCheckBox && value.Timeto) {
                await submitForm();
              } else {
                notify('Link Expiry date is required!');
              }
            } else {
              notify('Fill username and password');
            }
          } else {
            notify('Add at least one email!');
          }
        } else {
          notify('Email Restrict is required');
        }
      } else if (value.bymobile && value.bypassword) {
        if (mobileRestricCheckbox) {
          if (mobileList.length) {
            if (value.username && value.password) {
              if (linkCheckBox && value.Timeto) {
                await submitForm();
              } else {
                notify('Link Expiry date is required!');
              }
            } else {
              notify('Fill username and password');
            }
          } else {
            notify('Add at least one mobile number!');
          }
        } else {
          notify('Mobile Restrict is required');
        }
      } else if (value.byemail) {
        if (emailRestricCheckbox) {
          if (emailList.length) {
            if (linkCheckBox && value.Timeto) {
              await submitForm();
            } else {
              notify('Link Expiry date is required!');
            }
          } else {
            notify('Add at least one email!');
          }
        } else {
          notify('Email Restrict is required');
        }
      } else if (value.bymobile) {
        if (mobileRestricCheckbox) {
          if (mobileList.length) {
            if (linkCheckBox && value.Timeto) {
              await submitForm();
            } else {
              notify('Link Expiry date is required!');
            }
          } else {
            notify('Add at least one mobile number!');
          }
        } else {
          notify('Mobile Restrict is required');
        }
      } else if (value.bypassword) {
        if (value.username && value.password) {
          if (linkCheckBox && value.Timeto) {
            await submitForm();
          } else {
            notify('Link Expiry date is required!');
          }
        } else {
          notify('Fill username and password');
        }
      } else if (linkCheckBox && value.Timeto) {
        await submitForm();
      } else {
        notify('Link Expiry date is required!');
      }
    }
  });
  const handleCheckboxChange = (name, value) => {
    if (name == 'bypassword' && !!value) {
      formik.setFieldValue('username', '');
      formik.setFieldValue('password', '');
    }
    formik.setFieldValue(name, !value);
  };
  const handleLinkCheckBox = value => {
    setLinkCheckBox(value);
    if (!value) {
      formik.setFieldValue('Timeto', '');
    }
  };
  const handleEmailCheckBox = value => {
    setEmailRestricCheckbox(value);
    if (!value) {
      setEmailList([]);
    }
  };
  const handleMobileCheckBox = value => {
    setMobileRestricCheckbox(value);
    if (!value) {
      setMobileList([]);
    }
  };
  console.log(formik.values);

  return (
    <>
      <Drawer open={open} onClose={close} size="xs" backdrop="static">
        <Drawer.Header>
          <Drawer.Title>Link security</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <Drawer.Actions
            className="Privacy-header"
            style={{ textAlign: 'left', padding: '10px 0', gap: '20px', display: 'flex' }}
          >
            {[1, 2].map(buttonNumber => (
              <Button
                key={buttonNumber}
                appearance={activeButton === buttonNumber ? 'primary' : 'default'}
                onClick={() => setActiveButton(buttonNumber)}
                color="cyan"
              >
                {buttonNumber === 1 ? 'Privacy Control' : 'Display Settings'}
              </Button>
            ))}
          </Drawer.Actions>
          <form onSubmit={formik.handleSubmit}>
            {activeButton === 1 ? (
              <PrivacyControlForm
                formik={formik}
                handleCheckboxChange={handleCheckboxChange}
                emailList={emailList}
                setEditRestic={setEditRestic}
                linkCheckBox={linkCheckBox}
                handleLinkCheckBox={handleLinkCheckBox}
                setEditRestic2={setEditRestic2}
                handleEmailCheckBox={handleEmailCheckBox}
                emailRestricCheckbox={emailRestricCheckbox}
                mobileRestricCheckbox={mobileRestricCheckbox}
                handleMobileCheckBox={handleMobileCheckBox}
                setEmailList={setEmailList}
                setEmailRestricCheckbox={setEmailRestricCheckbox}
                setMobileList={setMobileList}
                setMobileRestricCheckbox={setMobileRestricCheckbox}
                mobileList={mobileList}
              />
            ) : (
              <DisplaySettingsForm formik={formik} handleCheckboxChange={handleCheckboxChange} />
            )}
          </form>
        </Drawer.Body>
      </Drawer>
      {editRestic && (
        <GenerateAccessUpdate
          open={editRestic}
          close={() => setEditRestic(false)}
          emailList={emailList}
          typeCode={typeCode}
          setEmailList={setEmailList}
        />
      )}
      {editRestic2 && (
        <GenerateMobileAccessUpdate
          open={editRestic2}
          close={() => setEditRestic2(false)}
          mobileList={mobileList}
          typeCode={typeCode}
          setMobileList={setMobileList}
        />
      )}
    </>
  );
}

const PrivacyControlForm = ({
  formik,
  handleCheckboxChange,
  emailList,
  setEditRestic,
  linkCheckBox,
  handleLinkCheckBox,
  setEditRestic2,
  handleEmailCheckBox,
  emailRestricCheckbox,
  mobileRestricCheckbox,
  handleMobileCheckBox,
  setEmailList,
  setEmailRestricCheckbox,
  setMobileList,
  setMobileRestricCheckbox,
  mobileList
}) => (
  <div className="Privacy-tab">
    <div style={{ marginBottom: '100px' }}>
      <Panel header="Privacy Control" shaded>
        <Checkbox
          name="byemail"
          value={formik.values.byemail}
          checked={formik.values.byemail}
          onChange={() => {
            formik.values.byemail && setEmailList([]);
            formik.values.byemail && setEmailRestricCheckbox(false);
            handleCheckboxChange('byemail', formik.values.byemail);
            formik.setFieldValue('emailotp', !formik.values.emailotp);
          }}
        >
          Email Required to view catalogue
        </Checkbox>
        <div className="GAuthPrivacy">
          <div>
            <Checkbox
              name="emailotp"
              value={formik.values.emailotp}
              checked={formik.values.emailotp}
              disabled={!formik.values.byemail}
            >
              OTP verification required
            </Checkbox>
            <div className="note-left">
            Viewer must verify their email via OTP to access your catalogue
            </div>
          </div>
          <div>
            <Checkbox
              disabled={!formik.values.byemail}
              value={emailRestricCheckbox}
              checked={emailRestricCheckbox}
              onChange={() => handleEmailCheckBox(!emailRestricCheckbox)}
            >
              {' '}
              Restrict Access
            </Checkbox>
          </div>
          <div className="note-left">
            {emailList?.length ? emailList.filter(item => item.emailsts == true).length : 0} email
            Allowed
          </div>
          <div className="note-left">
            <button
              onClick={() => setEditRestic(true)}
              type="button"
              disabled={!formik.values.byemail || !formik.values.emailotp || !emailRestricCheckbox}
            >
              Allow or block specific users <ArrowRightLineIcon />
            </button>
          </div>
        </div>
      </Panel>
      <Panel shaded>
        <Checkbox
          name="bymobile"
          checked={formik.values.bymobile}
          value={formik.values.bymobile}
          onChange={() => {
            formik.values.bymobile && setMobileList([]);
            formik.values.bymobile && setMobileRestricCheckbox(false);
            handleCheckboxChange('bymobile', formik.values.bymobile);
            formik.setFieldValue('mobileotp', !formik.values.mobileotp);
          }}
        >
          Phone number is required to view catalogue
        </Checkbox>
        <div className="GAuthPrivacy">
          <Checkbox
            name="mobileotp"
            value={formik.values.mobileotp}
            checked={formik.values.mobileotp}
            disabled={!formik.values.bymobile}
          >
            OTP verification required
          </Checkbox>
          <br />
          <div className="note-left">
          Verify Phone no to make Catalogue visible
          </div>
          <div>
            <Checkbox
              disabled={!formik.values.mobileotp}
              value={mobileRestricCheckbox}
              checked={mobileRestricCheckbox}
              onChange={() => handleMobileCheckBox(!mobileRestricCheckbox)}
            >
              Restrict Access
            </Checkbox>
          </div>
          <div className="note-left">
            {mobileList?.length ? mobileList.filter(item => item.mobilests == true).length : 0}{' '}
            mobile number Allowed
          </div>
          <div className="note-left">
            <button
              onClick={() => setEditRestic2(true)}
              type="button"
              disabled={
                !formik.values.mobileotp || !formik.values.bymobile || !mobileRestricCheckbox
              }
            >
              Allow or block specific users <ArrowRightLineIcon />
            </button>
          </div>
        </div>
      </Panel>
      <Panel shaded>
        <Checkbox
          value={formik.values.bypassword}
          checked={formik.values.bypassword}
          name="bypassword"
          onChange={() => handleCheckboxChange('bypassword', formik.values.bypassword)}
        >
          User Id
        </Checkbox>
        <div
          className="GAuthPrivacy-date"
          style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}
        >
          <Input
            placeholder="Enter Username"
            onChange={value => {
              const replacedValue = value.replace(/\s+/g, ' ');
              const trimmedValue = replacedValue.startsWith(' ')
                ? replacedValue.slice(1)
                : replacedValue;
              formik.setFieldValue('username', trimmedValue);
            }}
            value={formik.values.username}
            name="username"
            disabled={!formik.values.bypassword}
          />
          <Input
            placeholder="Enter Password"
            value={formik.values.password}
            onChange={value => formik.setFieldValue('password', value.trim())}
            disabled={!formik.values.bypassword}
            name="password"
          />
        </div>
      </Panel>
      <Panel shaded>
        <Checkbox
          value={linkCheckBox}
          name="byLink"
          checked={linkCheckBox}
          onChange={() => handleLinkCheckBox(!linkCheckBox)}
        >
          Link expires on
        </Checkbox>
        <div className="note-left">
          Link will be automatically deactivated after the selected date
        </div>
        <div className="GAuthPrivacy-date">
          <DatePicker
            format="dd MMM yyyy hh:mm:ss aa"
            placement="leftEnd"
            showMeridian
            caretAs={FaCalendar}
            style={{ width: '100%' }}
            value={formik.values.Timeto}
            onChange={value => formik.setFieldValue('Timeto', value)}
            disabled={!linkCheckBox}
          />
        </div>
      </Panel>
    </div>
    <PrivacyFooter formik={formik} handleCheckboxChange={handleCheckboxChange} />
  </div>
);

const DisplaySettingsForm = ({ formik, handleCheckboxChange }) => (
  <div className="Privacy-tab">
    <Panel shaded>
      <Checkbox
        name="downloadppt"
        value={formik.values.downloadppt}
        checked={formik.values.downloadppt}
        onChange={() => handleCheckboxChange('downloadppt', formik.values.downloadppt)}
      >
        Download PPT
      </Checkbox>
    </Panel>
    <Panel shaded>
      <Checkbox
        name="showfilter"
        value={formik.values.showfilter}
        checked={formik.values.showfilter}
        onChange={() => handleCheckboxChange('showfilter', formik.values.showfilter)}
      >
        Show Filters
      </Checkbox>
    </Panel>
    <Panel shaded>
      <Checkbox
        name="SlideShow"
        value={formik.values.SlideShow}
        checked={formik.values.SlideShow}
        onChange={() => handleCheckboxChange('SlideShow', formik.values.SlideShow)}
      >
        SlideShow
      </Checkbox>
    </Panel>
    <Panel shaded>
      <Checkbox
        name="SmartSearch"
        value={formik.values.SmartSearch}
        checked={formik.values.SmartSearch}
        onChange={() => handleCheckboxChange('SmartSearch', formik.values.SmartSearch)}
      >
        Smart Search
      </Checkbox>
    </Panel>
    <Panel shaded>
      <Checkbox
        name="visualProduct"
        value={formik.values.visualProduct}
        checked={formik.values.visualProduct}
        onChange={() => handleCheckboxChange('visualProduct', formik.values.visualProduct)}
      >
        Space Visualization
      </Checkbox>
    </Panel>
    <PrivacyFooter formik={formik} handleCheckboxChange={handleCheckboxChange} />
  </div>
);

const PrivacyFooter = ({ formik, handleCheckboxChange }) => (
  <Panel shaded className="Privacy-footer">
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Checkbox
        name="setasdefault"
        value={formik.values.setasdefault}
        checked={formik.values.setasdefault}
        onChange={() => handleCheckboxChange('setasdefault', formik.values.setasdefault)}
      >
        Set as Default
      </Checkbox>
      <Button appearance="primary" type="submit" color="cyan">
        Update Setting
      </Button>
    </div>
  </Panel>
);
